import * as React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import s from "./TextFooterWidget.module.scss";

Scrivito.provideComponent("TextFooterWidget", ({ widget }) => {
  const title = widget.get("title") && (
    <Scrivito.ContentTag
      content={widget}
      attribute="title"
      tag="h5"
      id="footer-text__title"
    />
  );

  const text = widget.get("text") && (
    <Scrivito.ContentTag content={widget} attribute="text" tag="div" />
  );

  return (
    <div className={cx("row", s.footerWidgetText)}>
      <div className="col-md-12">
        <aside>
          {title}
          {text}
        </aside>
      </div>
    </div>
  );
});
